export const awPerformanceRootPath = '/v1/performance';
export const awPerformanceDefaultRequestData = {
  purpose: 'PROD',
  includeBenchmark: false,
};
export enum TimePeriodsEnum {
  '1d' = '1d',
  '1w' = '1w',
  itd = 'itd',
  mtd = 'mtd',
  qtd = 'qtd',
  ytd = 'ytd',
}
